import React from 'react'

const Loader = () => {
  return (
    <div  className="loading-container active">
    <div className="loading-wrapper">
      <span className="circle circle-1"></span>
      <span className="circle circle-2"></span>
      <span className="circle circle-3"></span>
      <span className="circle circle-4"></span>
      <span className="circle circle-5"></span>
      <span className="circle circle-6"></span>
      <span className="circle circle-7"></span>
      <span className="circle circle-8"></span>
    </div>
    </div>
  )
}

export default Loader